<template>
  <article class="px-0 py-0 my-0">
    <section class="section-daten-liefern px-7 px-xl-9 m-0">
      <div style="max-width:1280px" class="mx-auto">
        <h1 class="by-heading-2 text-by-blue-100 mb-5">EU-Durchführungsverordnung "High Value Datasets"</h1>
        <div class="introduction-container">
          <p class="restrict-max-width mb-0 text-by-neutral-100">Die öffentliche Verwaltung muss hochwertige Daten ab dem 9. Juni 2024 auf eine bestimmte Weise zur Verfügung stellen. Wir klären Sie auf und unterstützen bei der Umsetzung!
          </p>
        </div>
      </div>
    </section>
    <section class="m-0 pt-11 pb-9 px-7 px-xl-9 pb-9">
      <div style="max-width:1280px" class="mx-auto">
        <h2 class="by-heading-3 text-by-blue-100">Unser Angebot</h2>
        <p class="restrict-max-width mt-2 text-by-neutral-100 by-copy-large-regular mb-9">
          Wir unterstützen Sie rund um die Umsetzung der EU-Durchführungsverordnung.
        </p>
        <div class="row">
          <div class="col-xs-12 col-xl-4 px-3 mb-3 mt-0 my-xl-0">
            <div class="event-card">
              <div class="mx-0 row">
                <div class="col-12 col-md-6 col-xl-12">
                  <h4 class="by-heading-4 text-by-blue-100 mb-1 mb-md-0"
                      style="">Unsere Handreichung</h4>
                </div>
                <div class="col-12 col-md-6 text-md-right text-xl-left">
                  <span class="by-copy-small-regular text-by-neutral-80">PDF</span>
                </div>
              </div>
              <div class="mt-4 mt-md-5 mx-0 row">
                <div class="col-xs-12 px-0 pr-md-4 px-xl-0 col-md-6 col-xl-12 d-flex flex-column justify-content-between">
                  <p class="by-copy-small-regular text-by-neutral-60 mb-4">
                    Unsere umfangreiche Handreichung mit allem, was Sie zur Verordnung wissen müssen.
                  </p>
                  <div class="d-flex">
                    <a href="/static/openbydata_HVD_Handreichung.pdf" class="by-btn-primary-large-light by-copy-large-semibold" download>Download</a>
                  </div>
                </div>
                <div class="col-xs-12 px-0 pl-md-4 px-xl-0 col-md-6 col-xl-12">
                  <p
                    class="mt-7 d-md-none d-xl-block by-copy-large-semibold text-by-neutral-100 mb-3">
                    Inhalt</p>
                  <ul class="content-list">
                    <li>Hintergrund zur Verordnung</li>
                    <li>Status-Quo in Deutschland</li>
                    <li>Prüfschritte für Sie vor Ort</li>
                    <li>Unterstützungsangebot durch open bydata</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-xl-4 px-3 my-3 my-xl-0">
            <div class="event-card">
              <div class="mx-0 row">
                <div class="col-12 col-md-6 col-xl-12">
                  <h4 class="by-heading-4 text-by-blue-100 mb-1 mb-md-0">Unsere Tabelle</h4>
                </div>
                <div class="col-12 col-md-6 text-md-right text-xl-left">
              <span class="by-copy-small-regular text-by-neutral-80">XLSX</span>
                </div>
              </div>
              <div class="mt-4 mt-md-5 mx-0 row">
                <div class="col-xs-12 px-0 pr-md-4 px-xl-0 col-md-6 col-xl-12 d-flex flex-column justify-content-between">
                  <p class="by-copy-small-regular text-by-neutral-60 mb-4">
                    Unsere Tabelle ermöglicht Ihnen, die betroffenen Datenthemen Schritt für Schritt zu prüfen.</p>
                  <div class="d-flex">
                    <a href="/static/openbydata_HVD_Tabelle.xlsx" class="by-btn-primary-large-light by-copy-large-semibold">Download</a>
                  </div>
                </div>
                <div class="col-xs-12 px-0 pl-md-4 px-xl-0 col-md-6 col-xl-12">
                  <p
                    class="mt-7 d-md-none d-xl-block by-copy-large-semibold text-by-neutral-100 mb-3">
                    Inhalt</p>
                  <ul class="content-list">
                    <li>Überblick zu allen betroffenen Datenthemen</li>
                    <li>Angabe möglicher Sammelstellen aller Verwaltungsebenen</li>
                    <li>Weiterführende Informationen</li>
                    <li>Platz für eigene Notizen bei der Prüfung</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-xl-4 px-3 mt-3 mb-0 my-xl-0">
            <div class="event-card">
              <div class="mx-0 row">
                <div class="col-12 col-md-6 col-xl-12">
                  <h4 class="by-heading-4 text-by-blue-100 mb-1 mb-md-0">
                    Unsere Beratung</h4>
                </div>
                <div class="col-12 col-md-6 text-md-right text-xl-left">
              <span class="by-copy-small-regular text-by-neutral-80">
                <img class="mr-1"
                     style="width: 1.5rem; height: 1.5rem;"
                     src="../assets/icon/icon-clock.svg"/>variabel</span>
                </div>
              </div>
              <div class="mt-4 mt-md-5 mx-0 row">
                <div class="col-xs-12 px-0 pr-md-4 px-xl-0 col-md-6 col-xl-12 d-flex flex-column justify-content-between">
                  <p class="by-copy-small-regular text-by-neutral-60 mb-4" style="height: 4.5rem;">
                    Wir beraten individuell zu all Ihren Fragen als Datenbereitsteller.
                  </p>
                  <div class="d-flex">
                    <a href="mailto:openbydata@byte.bayern?subject=HVD-Beratung&body=Guten%20Tag%2C%0D%0A%0D%0Aich%20bzw.%20wir%20sind%20daran%20interessiert%2C%20eine%20Beratung%20zum%20Thema%2C%20High%20Value%20Datasets%20zu%20bekommen.%0D%0A%0D%0AEin%20m%C3%B6glicher%20Terminvorschlag%20w%C3%A4re%3A%0D%0A%5Bbitte%20hier%20einf%C3%BCgen%5D%0D%0A%0D%0AFreundliche%20Gr%C3%BC%C3%9Fe%0D%0A" class="by-btn-primary-large-light by-copy-large-semibold">Kostenfreie Terminanfrage</a>
                  </div>
                </div>
                <div class="col-xs-12 px-0 pl-md-4 px-xl-0 col-md-6 col-xl-12">
                  <p
                    class="mt-7 d-md-none d-xl-block by-copy-large-semibold text-by-neutral-100 mb-3">
                    Inhalt</p>
                  <ul class="content-list">
                    <li>Individuelle Beratung zur HVD-Verordnung</li>
                    <li>Information zur Datenbereitstellung via open bydata</li>
                    <li>Demonstration automatisierte Bereitstellung über unsere Schnittstelle oder Harvester</li>
                    <li>Überblick zu nötigen und empfohlenen Angaben zu einem Datensatz</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="m-0 pt-9 pb-11 px-7 px-xl-9 pb-9 bg-by-neutral-5">
      <div style="max-width:1280px" class="mx-auto text-center">
        <h4 class="by-heading-4 text-by-blue-100 mb-5">Kommen Sie auf uns zu.</h4>
        <p class="by-heading-5 text-by-neutral-60 mb-7 d-none d-md-block">
          "Wir sorgen dafür, dass Ihre Daten unkompliziert nutzbar sind. Arbeiten Sie mit uns an
          einem besseren Bayern durch Daten!"
        </p>
        <p class="by-heading-4 text-by-neutral-60 mb-7 d-md-none">
          "Wir sorgen dafür, dass Ihre Daten unkompliziert nutzbar sind. Arbeiten Sie mit uns an
          einem besseren Bayern durch Daten!"
        </p>
        <img src="../assets/img/Max.png" class="mb-2 d-md-none"
             style="border-radius: 6rem; width: 6rem; height: 6rem;"/>
        <img src="../assets/img/Max.png" class="mb-2 d-none d-md-inline d-xl-none"
             style="border-radius: 7.5rem; width: 7.5rem; height: 7.5rem;"/>
        <img src="../assets/img/Max.png" class="mb-2 d-none d-xl-inline"
             style="border-radius: 10rem; width: 10rem; height: 10rem;"/>
        <p class="by-copy-small-semibold text-by-neutral-100 mb-0">
          Maximilian Melle
        </p>
        <p class="by-copy-small-regular text-by-neutral-100 mb-4">
          Product Owner für Open Data
        </p>
        <div class="d-inline-block">
          <a href="mailto:openbydata@byte.bayern "
             class="by-btn-primary-large-light mt-7 btn-mail">
            Eine Nachricht schreiben</a>
        </div>
      </div>
    </section>
  </article>
</template>
<style lang="scss" scoped>
.btn-mail {
  display: flex;
  padding: 11px 1.5rem;
  align-items: center;
  background-color: var(--by-neutral-5);
  color: var(--by-neutral-100);

  &::before {
    color: white;
    content: '';
    width: 24px;
    height: 24px;
    margin-right: .5rem;
    background: url('../assets/icon/icon-envelope.svg') no-repeat;
  }
}

.btn-login {
  &::after {
    content: '';
    width: 24px;
    height: 24px;
    margin-left: .5rem;
    background: url('../assets/icon/icon-caretright.svg') no-repeat;
  }
}

.introduction-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.section-daten-liefern {
  padding-top: 8.5rem;
  padding-bottom: 8.5rem;
}
</style>
<style>
.custom-article-truncate {
  display: -webkit-box;
  -webkit-line-clamp: 4; /* Number of lines to display */
  line-clamp: 4; /* Number of lines to display */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.embed-responsive-2by1::before {
  content: "";
  padding-top: 50%
}

h1.by-heading-2 {
  hyphens: auto;
}
</style>
<script>
export default {
  name: "Info",
  metaInfo() {
    const title = "High Value Datasets EU-Verordnung - open bydata";
    return {
      titleTemplate(chunk) {
        return title;
      },
    };
  },
  methods: {
    login() {
      if (!this.$keycloak) {
        console.error("Keycloak not initialized!");
        return;
      }
      
      this.$keycloak.loginFn();
    },
  }
}
</script>